import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../containers/Modal/ModalContainer";
import { ApplicationDetailService } from "../../services/ApplicationDetailService";
import ApplicationDetails from "./ApplicationDetails/AplicationDetails";

export function NewApplicationModal({ isOpen, managers, close, interviewId }) {
  const [applicationDetail, setApplicationDetail] = useState({});
  useEffect(() => {
    setApplicationDetail({ interviewId: interviewId });
  }, []);
  const [errors, setErrors] = useState({});
  let { t } = useTranslation();
  function onChange({ target }) {
    setApplicationDetail({
      ...applicationDetail,
      [target.name]: target.value
    });
  }

  function createNewApplication() {
    let _errors = {};
    if (!applicationDetail.date)
      _errors.applicationDetailDate = t("application date is required.");
    if (!applicationDetail.candidateSourceId)
      _errors.applicationDetailSource = t(
        " Candidate application Source is required."
      );

    if (!applicationDetail.assignUserId) {
      _errors.applicationDetailAssignUserId = t(" Assign user  is required.");
    }
    setErrors(_errors);
    if (Object.keys(_errors).length > 0) return;
    ApplicationDetailService.Create(applicationDetail).then((data) => {
      setApplicationDetail({
        interviewId: interviewId
      });
      close(data);
    });
  }
  function closeModal() {
    close();
  }
  return (
    <ModalContainer
      isOpen={isOpen}
      modalTitle={t("New Application")}
      closeModal={closeModal}
      crossmarkAction={closeModal}
      cancelButtonAction={closeModal}
      cancelButtonTitle="Cancel"
      submitButtonTitle="Create"
      modalSize="xl"
      submitButtonAction={createNewApplication}
    >
      <ApplicationDetails
        errors={errors}
        current={true}
        managers={managers}
        applicationDetail={applicationDetail}
        onChange={onChange}
        interviewId={interviewId}
        isOpen={isOpen}
      />
    </ModalContainer>
  );
}
